import { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, InputField } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { Toast } from '../../../services';
import { useSelector } from 'react-redux';
import { RootState } from '../../../store';

const AddDimension = ({ data }: any) => {
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad } = data;
    const { authProject } = useSelector((state: RootState) => state.auth);
    const defaultFormObj = {
        id: selectedItem.id ? selectedItem.id : null,
        name: selectedItem.name ? selectedItem.name : "",
        code: selectedItem.code ? selectedItem.code :  "",
        projectId: selectedItem.projectId ? selectedItem.projectId : authProject.id,
    };
    const [formField, setFormField] = useState(defaultFormObj);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value
        });
    };

    const isValidInput = (formObj: any) => {
        if (!formObj.name || !formObj.name.trim()) {
            Toast('Please enter dimension name', "error");
            return false;
        }
        if (!formObj.code || !formObj.code.trim()) {
            Toast('Please enter dimension code', "error");
            return false;
        }
        return true;
    }

    const handleTaxonomyType = () => {
        if (!isValidInput(formField)) return;
        HttpService.postRequest(API_URL.ADD_TAXONOMY_TYPE, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ? 'Dimension updated successfully.' :  'Dimension added successfully.', "success");
                setIsOpenAddEdit(false);
                setIsLoad(true);
            },
            (err: any) => {
                Toast(err.message, "error");
            }
        )
    }

    const generateCode = () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter dimension name', "error");
            return false;
        }
        HttpService.postRequest(API_URL.GENERATE_CODE, formField.name).then(
            (res: any) => {
                setFormField({
                    ...formField,
                    code: res ? res : null
                });
            }
        ).catch((err: any) => {
            Toast(err.message, "error");
        });
    }

    return (
        <div>
            <Modal
                isOpen={isOpenAddEdit}
                srLabelledBy={'modal-id-dimension'}
                srDescribedBy={'modal-id-dimension'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-dimension'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    {selectedItem?.id ? 'Edit Dimension' : 'Add Dimension'}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-dimension">
                    <div className='wk-grid-page-container p-0'>
                        <div className="wk-grid mt-10">
                            <div className="wk-column-12">
                                <InputField label="Name" labelFor="dimension-name-1" size="small" indicator="required">
                                    <input
                                        type="text" id="dimension-name-1" name="name"
                                        placeholder="Dimension Name"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.name} autoComplete="off"
                                    />
                                </InputField>
                                <div className="cg-field-header">
                                    <label className="cg-field-label pt-15">Code <div className="cg-field-required-indicator"><span aria-hidden="true">*</span><div data-e2e="cg-sr-only" className="cg-sr-only">Required field</div></div></label>
                                    <div className="pt-5">
                                        <button type="button" className="border border-primary btn btn btn-outline-light text-bg-light"
                                            style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3' }}
                                            onClick={generateCode}>
                                            Generate Code
                                        </button>
                                    </div>
                                </div>
                                <InputField label="" labelFor="dimension-code-1" size="small" indicator="required">
                                    <input
                                        type="text" id="dimension-code-1" name="code"
                                        placeholder="Dimension Code"
                                        readOnly
                                        value={formField.code} autoComplete="off"
                                    />
                                </InputField>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} iconPosition={'left'}>
                                <button
                                    className='mr-10'
                                    type="button"
                                    id="save"
                                    onClick={handleTaxonomyType}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddDimension;